(function () {
  'use strict';

  // ── INIT GUARD ─────────────────────────────────────────────────────────────
  var section = document.querySelector('.sn-ing');
  if (!section || section.dataset.snIngInit) return;
  section.dataset.snIngInit = '1';

  var filters     = section.querySelectorAll('.sn-ing__filter');
  var cards       = Array.prototype.slice.call(section.querySelectorAll('.sn-ing__card'));
  var dialog      = document.getElementById('sn-ing-dialog');
  var slot        = document.getElementById('sn-ing-dialog-slot');
  var closeBtn    = document.getElementById('sn-ing-dialog-close');
  var progressBar = document.getElementById('sn-ing-dialog-progress-bar');
  var hero        = null;   // active SnHero controller (the open dialog)
  var plainOpener = null;   // opener when the engine script is missing

  if (!filters.length || !cards.length) return;

  // ── FILTER ─────────────────────────────────────────────────────────────────
  function cardMatchesFilter(card, filter) {
    if (filter === 'all') return true;
    var raw = (card.getAttribute('data-products') || '').trim();
    if (!raw) return false;
    // Split on one or more whitespace chars: handles trailing spaces from Liquid
    var tags = raw.split(/\s+/);
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === filter) return true;
    }
    return false;
  }

  function applyFilter(filter) {
    cards.forEach(function (card) {
      card.hidden = !cardMatchesFilter(card, filter);
    });
  }

  filters.forEach(function (pill) {
    pill.addEventListener('click', function () {
      filters.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
      applyFilter(pill.dataset.filter || 'all');
    });
  });

  // ── SCROLL PROGRESS ────────────────────────────────────────────────────────
  if (slot && progressBar) {
    slot.addEventListener('scroll', function () {
      var max = slot.scrollHeight - slot.clientHeight;
      var pct = max > 0 ? Math.round((slot.scrollTop / max) * 100) : 100;
      progressBar.style.width = pct + '%';
    }, { passive: true });
  }

  // ── DIALOG OPEN ────────────────────────────────────────────────────────────
  // The card's image flies into the dialog and back on the shared hero flight
  // (assets/sn-hero-flight.js). SnHero owns the scroll lock, Esc, focus return
  // and the fallback for a card that is gone or off screen; this file hands it
  // the card and the dialog's picture.

  // Swap the dialog's picture for the larger file once that has decoded.
  function upgrade(img, full) {
    if (!img || !full) return;
    var big = new Image();
    big.src = full;
    (big.decode ? big.decode() : Promise.resolve()).then(function () {
      if (img.isConnected) img.src = full;
    }, function () {});
  }

  function openDialog(card) {
    if (!dialog || !slot || dialog.open || (hero && hero.isOpen)) return;
    var tmpl = document.getElementById('sn-ing-tmpl-' + card.dataset.block);
    if (!tmpl) return;

    slot.innerHTML = '';
    slot.appendChild(tmpl.content.cloneNode(true));
    slot.scrollTop = 0;
    if (progressBar) progressBar.style.width = '0%';

    // Start the dialog's picture from the card's own, already decoded file (no
    // blank frame when the flight lands), then swap to the larger one.
    var cardMedia = card.querySelector('.sn-ing__card-media');
    var cardImg   = cardMedia && cardMedia.querySelector('img');
    var dialogImg = slot.querySelector('.sn-ing-dialog__media img');
    var full      = dialogImg && dialogImg.getAttribute('src');
    if (cardImg && dialogImg) {
      dialogImg.removeAttribute('loading');
      dialogImg.src = cardImg.currentSrc || cardImg.src;
    }

    if (!window.SnHero) {
      // Engine script missing: open plainly, without the flight.
      plainOpener = card;
      dialog.setAttribute('data-sn-hero', 'open');
      dialog.setAttribute('data-sn-hero-content', 'in');
      dialog.showModal();
      return;
    }

    hero = window.SnHero.open({
      dialog: dialog,
      opener: card,
      source: cardImg ? cardMedia : null,
      target: function () { return slot.querySelector('.sn-ing-dialog__media'); },
      // Read when the close starts: a card the filter pills have hidden since
      // is not rendered, so SnHero uses its scale-and-fade fallback.
      closeTarget: function () { return card.querySelector('.sn-ing__card-media'); },
      mode: 'rect',
      ready: function () { return dialogImg && dialogImg.decode ? dialogImg.decode() : null; },
      onSettle: function () { upgrade(dialogImg, full); },
      onClosed: function () { hero = null; }
    });
  }

  // ── DIALOG CLOSE ──────────────────────────────────────────────────────────
  function closeDialog() {
    if (hero) hero.close();
    else if (dialog && dialog.open) dialog.close();
  }

  // ── CARDS ─────────────────────────────────────────────────────────────────
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      openDialog(card);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openDialog(card);
      }
    });
  });

  // ── CLOSE TRIGGERS ────────────────────────────────────────────────────────
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDialog);
  }

  if (dialog) {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });
    // Only does anything without the engine; SnHero cleans up after its own.
    dialog.addEventListener('close', function () {
      if (!plainOpener) return;
      dialog.removeAttribute('data-sn-hero');
      dialog.removeAttribute('data-sn-hero-content');
      plainOpener.focus();
      plainOpener = null;
    });
  }

})();
